import styled from 'styled-components';

export const CartaoContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  border-radius: 10px;
  background-color: #f9f9f9;
  max-width: 280px;
  width: 100%;
`;

export const ImagemContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100px;

  @media (min-width: 1200px) {
    height: 100px;
  }
`;

export const SeloOriginal = styled.img`
  width: 30px;
  position: absolute;
  top: 0;
  left: 0;
  padding: 5px;
`;

export const Rotulo = styled.span`
  position: absolute;
  bottom: -10px;
  left: 10px;
  padding: 3px 5px;
  background-color: ${({ theme }) => theme.colors.accent.accent[9]};
  max-width: 50px;
`;

export const Corpo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const AutorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

export const ImagemPerfil = styled.div`
  position: relative;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.accent.accent_alpha[7]};
  margin-right: 10px;
`;
